import { Stack } from "@fluentui/react";
import { animated, useSpring } from "@react-spring/web";
import { useEffect, useState } from "react";

import styles from "./Answer.module.css";
import { AnswerIcon } from "./AnswerIcon";

export const AnswerLoading = () => {
    const loadingPhrases = [
        "Calentando motores...",
        "Poniendo primera, ya te digo...",
        "Dame un chancecito, maje...",
        "Espera un segundo, vale la pena...",
        "Prendiendo motores..."
    ];
    
    const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentPhraseIndex((prevIndex) => (prevIndex + 1) % loadingPhrases.length);
        }, 2500);
        
        return () => clearInterval(interval);
    }, [loadingPhrases.length]);
    
    const animatedStyles = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 }
    });

    return (
        <animated.div style={{ ...animatedStyles }}>
            <Stack className={styles.answerContainer} verticalAlign="space-between">
                <AnswerIcon />
                <Stack.Item grow>
                    <p className={styles.answerText}>
                        {loadingPhrases[currentPhraseIndex]}
                        <span className={styles.loadingdots} />
                    </p>
                </Stack.Item>
            </Stack>
        </animated.div>
    );
};
